import axios from "axios";
import { BASE_URL } from "../config";

const getAuthHeaders = () => {
  const token =
    localStorage.getItem("authentication/token") ||
    localStorage.getItem("auth_token") ||
    localStorage.getItem("token") ||
    "";

  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getProviderPaymentHolidayList = (params) =>
  axios.get(`${BASE_URL}/provider-payment/batch-add-holiday/list`, {
    params,
    headers: getAuthHeaders(),
  });

export const getProviderPaymentHolidayById = (holidayId) =>
  axios.get(`${BASE_URL}/provider-payment/batch-add-holiday/list/${holidayId}`, {
    headers: getAuthHeaders(),
  });

export const addProviderPaymentHoliday = (payload) =>
  axios.post(`${BASE_URL}/provider-payment/batch-add-holiday/list/add`, payload, {
    headers: getAuthHeaders(),
  });

export const deleteProviderPaymentHoliday = (holidayId) =>
  axios.post(
    `${BASE_URL}/provider-payment/batch-add-holiday/list/delete`,
    { holiday_id: holidayId },
    { headers: getAuthHeaders() }
  );

export const uploadProviderPaymentBatchAddHoliday = (formData) =>
  axios.post(`${BASE_URL}/provider-payment/batch-add-holiday/upload`, formData, {
    headers: {
      ...getAuthHeaders(),
      "Content-Type": "multipart/form-data",
    },
  });

export const getProviderPaymentBatchAddHolidayUploadHistory = (params) =>
  axios.get(`${BASE_URL}/provider-payment/batch-add-holiday/uploads`, {
    params,
    headers: getAuthHeaders(),
  });

export const getProviderPaymentBatchAddHolidayProcessedRows = (uploadId, params) =>
  axios.get(`${BASE_URL}/provider-payment/batch-add-holiday/processed/${uploadId}`, {
    params,
    headers: getAuthHeaders(),
  });

export const exportProviderPaymentBatchAddHolidayProcessedRows = (uploadId, params) =>
  axios.post(
    `${BASE_URL}/provider-payment/batch-add-holiday/processed-export/${uploadId}`,
    {},
    {
      params,
      headers: getAuthHeaders(),
      responseType: "blob",
    }
  );

export const refreshProviderPaymentBatchAddHolidayUploadSignedUrl = (uploadId) =>
  axios.post(
    `${BASE_URL}/provider-payment/batch-add-holiday/refresh-url`,
    { upload_id: uploadId },
    { headers: getAuthHeaders() }
  );
